export const goToTop = () => {
    // Get the button:
    const goToTopButton = document.getElementById('goToTopButton');

    // When the user clicks on the button, scroll to the top of the document
    function topFunction() {
        document.getElementById('top').scrollIntoView({
            behavior: 'instant',
            block: 'center',
            inline: 'nearest',
        });

        $('html').attr('data-scrolldir', 'up'); // Necessary to show the site-header

        this.blur();
    }

    function scrollFunction() {
        if (!goToTopButton) {
            return;
        }

        if (
            document.body.scrollTop > 20 ||
            document.documentElement.scrollTop > 20
        ) {
            goToTopButton.style.display = 'block';
        } else {
            goToTopButton.style.display = 'none';
        }
    }

    if (goToTopButton) {
        goToTopButton.addEventListener('click', topFunction);
    }

    // When the user scrolls down 20px from the top of the document, show the button
    window.onscroll = () => {
        scrollFunction();
    };
};
